import {MoreAboutWorkflow} from './common/MoreAboutWorkflow';

export class Workflow {
  id?: number;
  enterpriseId?: number;
  description?: string;
  batch?: number;
  maxParticipants?: number;
  completed?: number;
  ready2Use?: number;
  deliver?: number;
  code?: string;
  type?: number;
  dynamic?: number;
  freelySignature?: boolean;
  minParticipantsToFinalize?: number;
  notificationByDocument?: boolean;
  completionAlertCharge?: boolean;
  extractCoordinates?: boolean;
  cancellationAlertReviewer?: boolean;
  documentSelection2Sign?: boolean;
  notificateAfterUpload?: boolean;
  send2MailAfterUpload?: boolean;
  send2Visualization?: boolean;
  // Notificación automatica
  notifyAfterUpload?: boolean;
  // Notificación  programada
  scheduledNotify?: boolean;
  xmlAsDatasource?: boolean;
  createAt?: string;
  active?: number;
  // tslint:disable-next-line:variable-name
  moreAboutWorkflow?: MoreAboutWorkflow;
  // tslint:disable-next-line:variable-name
  _more?: MoreAboutWorkflow;
}
